const initialState = {
    trades: [],
    attachments: [],
    postgreSQLRowData: [],
    tradeFormProps: {},
    childFormProps:{}
};

export default initialState;